import React, { createContext, useContext } from "react";
import { LexicalEditor, LexicalNode } from "lexical";
import { ChartContextNode } from "../../mdx-plugins/nodes/ChartNodes";
interface ChartContextValue {
  parentEditor: LexicalEditor;
  lexicalNode: ChartContextNode;
}

const ChartContext = createContext<ChartContextValue | null>(null);

export const ChartContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ChartContextValue;
}) => {
  return (
    <ChartContext.Provider value={value}>{children}</ChartContext.Provider>
  );
};

export const useChartContext = () => {
  const context = useContext(ChartContext);
  if (!context) {
    throw new Error(
      "useChartContext must be used within a ChartContextProvider"
    );
  }
  return context;
};
